import { CircularProgress, Tooltip, styled } from "@mui/material";

export const InputErrorSpan = styled("span")({
  marginTop: 1,
  color: "#CC1010",
  fontWeight: 400,
  fontSize: 8,
  lineHeight: "132%",
  marginLeft: "5px",
  marginBottom: 10,
});

export const ButtonLoader = styled(CircularProgress)({
  width: "16px !important",
  height: "16px !important",
  marginRight: "8px",
  color: "#F2F2F2",
});

const ToBeStyledTooltip = ({ className, ...props }) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
);
export const TooltipMUI = styled(ToBeStyledTooltip)({
  backgroundColor: "#f5f5f9",
  color: "rgba(0, 0, 0, 0.87)",
  border: "1px solid #dadde9",
  borderRadius: "20px",
  padding: "0px",

  " > div:first-child": {
    display: "none",
  },

  "& .MuiTooltip-arrow": {
    color: "black",
  },
});
